import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
var _excluded = ["code"];
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import useClipboardCopy from './useClipboardCopy';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CodeCopyButton(props) {
  var code = props.code,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var _useClipboardCopy = useClipboardCopy(),
    copy = _useClipboardCopy.copy,
    isCopied = _useClipboardCopy.isCopied;
  // This component is designed to be wrapped in NoSsr
  var macOS = window.navigator.platform.toUpperCase().includes('MAC');
  var key = macOS ? '⌘' : 'Ctrl + ';
  return /*#__PURE__*/_jsx("div", {
    className: "MuiCode-copy-container",
    children: /*#__PURE__*/_jsxs("button", _extends({}, other, {
      "aria-label": "Copy the code",
      type: "button",
      className: "MuiCode-copy",
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return copy(code);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })),
      children: [isCopied ? 'Copied' : 'Copy', /*#__PURE__*/_jsxs("span", {
        className: "MuiCode-copyKeypress",
        style: {
          opacity: isCopied ? 0 : 1
        },
        children: [/*#__PURE__*/_jsx("span", {
          children: "(or"
        }), " ", key, "C", /*#__PURE__*/_jsx("span", {
          children: ")"
        })]
      })]
    }))
  });
}